<template lang="pug">
pr-wrapper.animated.px-4.py-3.border(
  bg,
  :zi="index",
  :class="[payload.theme, { active: activated, reversed: payload.theme }]",
  nv-sleep-protect,
  nv-exit-protect,
  v-nv:scope="'toast'",
  @nv-exit.native="close",
  @nv-back.native="close"
)
  .tour-description(v-html="payload.content")
  .tour-buttons.d-inline-flex.mt-3(v-if="payload.confirmButton")
    pr-button.mr-2.background(v-nv, @nv-enter="select(true)") {{ payload.confirmButton }}
    pr-button.background(v-nv, @nv-enter="select(false)") {{ payload.cancelButton }}
</template>

<script>
// Placement values
//'auto' | 'auto-start' | 'auto-end' | 'top' | 'top-start' | 'top-end' | 'bottom' | 'bottom-start' | 'bottom-end' | 'right' | 'right-start' | 'right-end' | 'left' | 'left-start' | 'left-end';
import { createPopper } from "@popperjs/core"
export default {
  name: "toast",
  data() {
    return {
      activated: false,
      payload: {},
      lastNavigation: null,
      index: "0",
      timeout: null
    }
  },
  watch: {
    activated(nval) {
      this.$emit("activate", { name: this.$options.name, state: nval })
      this.index = nval ? "108" : "108"

      if (!nval) {
        if (this.popper) this.popper = this.popper.destroy()
        return false
      }
      this.popper = createPopper(document.querySelector(`.${this.payload.element || "top-end"}`), document.getElementById("toast"), {
        placement: "bottom-end"
      })
    }
  },
  mounted() {
    _$.vue.$on("toast", this.activate)
    _$.vue.$on("beforeRoute", () => this.close("abort"))
  },
  methods: {
    async activate(payload) {
      if (!payload) return this.close("abort")
      else if (payload === "skip") return this.close()

      if (this.activated) this.payload.reject()
      this.payload = payload

      await this.$nextTick()

      if (this.payload.confirmButton) {
        this.lastNavigation = this.lastNavigation || { current: _$.nav.getCurrentScope(), prev: _$.nav.getPrevScope() }
        await _$.nav.sync("toast", true)
        await _$.sleep(200)
      } else {
        if (this.timeout) this.timeout = window.clearTimeout(this.timeout)
        this.timeout = window.setTimeout(() => this.close(), this.payload.timeout || 3000)
      }

      this.activated = true
    },
    select(resp) {
      this.close(true, resp)
    },
    close(reason, resolve) {
      if (!this.activated) return false

      const res = {
        isConfirmed: resolve === true ? true : false,
        isDenied: resolve === false ? true : false,
        isCancelled: typeof resolve !== "boolean" ? true : false
      }

      if (this.lastNavigation && reason !== "abort") {
        if (this.lastNavigation.current) _$.nav.changeScope(this.lastNavigation.current.name)
        _$.nav._prevScope = this.lastNavigation.prev
      }

      this.lastNavigation = null
      this.activated = false

      if (this.timeout) this.timeout = window.clearTimeout(this.timeout)
      return this.payload.resolve(res)
    }
  }
}
</script>

<style lang="scss">
#toast {
  z-index: 99999;
  position: absolute;
  overflow: hidden;
  transform: translateY(100%);
  visibility: hidden;
  box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.45);
  max-width: 500px;

  &.active {
    transform: translateY(0);
    visibility: visible;
  }

  &.reversed {
    .nv-el-current {
      background: #fff !important;
      color: #333 !important;
    }
  }

  &.danger {
    background: #ff7675 !important;
  }

  &.success {
    background: #00b894 !important;
  }
}
</style>
